module.exports = __webpack_public_path__ + "static/nautical2-dceb08cd7af2405b26aa281f95ba8d20.png";